import apiClient from "./apiService";

// Fetch Transactions
export const fetchTransactions = async (page = 1, search = "", status = "") => {
  try {
    const params = new URLSearchParams();
    params.append("page", page);
    params.append("search", search || "");
    if (status) params.append("status", status);
    const response = await apiClient.get(
      `/admin/transactions/admin-index?${params.toString()}`,
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Get single transaction
export const viewTransaction = async (id) => {
  try {
    const response = await apiClient.get(`/api/transactions/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
